import {
  registerUser,
  editUser,
  uploadDocs,
  editDocs,
  removeDocs,
  findUserToday
} from "@/services/endpoints/users";
import { searchUsers, getUsers, findUser } from "@/services/endpoints/users";
import { getRoles, searchRoles } from "@/services/endpoints/roles";
export default {
  async registerUser({ commit }, payload) {
    // return new Promise((resolve, reject) => {
    try {
      let res = await registerUser(payload);
      if (res.data) {
        
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async findUser({ commit, getters }, payload) {
    try {
      let res = await findUser(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async findUserToday({ commit, getters }, payload) {
    try {
      let res = await findUserToday(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async switchUserStatus({ commit, getters }, payload) {
    try {
      let res = await editUser(payload.payload, payload.id);
      if (res.data) {
        
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async editUser({ commit, getters }, payload) {
    try {
      let res = await editUser(payload.items, payload.userId);
      if (res.data) {
        
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getReferralWays({ commit }) {
    try {
      let res = await getReferralWays();
      if (res.data) {
        
        commit("SET_REFERRAL_WAYS", res.data);
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getVisibleReferralWays({ commit }) {
    try {
      let res = await searchReferralWays({ status: "active", isVisible: true });
      if (res.data.data) {
        commit("SET_REFERRAL_WAYS", res.data.data);
        return res.data.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getActiveReferralWays({ commit }) {
    try {
      let res = await searchReferralWays({ status: "active" });
      if (res.data.data) {
        commit("SET_REFERRAL_WAYS", res.data.data);
        return res.data.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async searchUsers({ commit }, user) {
    try {
      let res = await searchUsers(user);
      if (res.data.data) {
        commit("SET_TOTAL", res.data.total);
        return res.data.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getRoles({ commit }) {
    try {
      let res = await getRoles();
      if (res.data) {
        commit("SET_ROLES", res.data);
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async searchRoles({ commit }, payload) {
    try {
      let res = await searchRoles(payload);
      if (res.data) {
        commit("SET_ROLES", res.data.data);
        return res.data.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async getUsers({ commit }, payload) {
    try {
      let res = await getUsers(payload);
      if (res.data) {
        commit("SET_USERS", res.data);
        return res.data.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async saveCitizenDocs({ commit }, payload) {
    try {
      for (let [key, value] of Object.entries(payload)) {
        if (key !== "formData") {
          if (value) {
            payload.formData.append(key, value);
          } else {
            payload.formData.append(key, null);
          }
        }
      }
      
      commit("SET_CITIZEN_IDENTIFICATION_DOCUMENT", payload.formData);
    } catch (err) {
      throw new Error(err);
    }
  },
  async uploadDocs({ state, commit }, properties) {
    // let numOfAddedFiles = state.filesList.length - state.allFiles.length;

    for (let i = state.filesList.length - 1; i >= state.allFiles.length; i--) {
      var payload = new FormData();
      properties.props.forEach((item) => {
        if (state.filesList[i] && state.filesList[i][item]) {
          payload.append(item, state.filesList[i][item]);
        } else {
          payload.append(item, null);
        }
      });
      if (properties.attachFileType) {
        payload.append("attachFileType", properties.attachFileType);
      }
      commit("ADD_TO_ADDED_FILES", payload);
    }
    try {
      let requests = [];
      let response;
      if (state.addedFiles.length) {
        state.addedFiles.forEach((c) => {
          requests.push(uploadDocs(c, properties.id));
        });
        response = await Promise.all(requests)
          .then((responses) => {
            return responses.map((r) => r.data);
            // return [...responses.data]
          })
          .catch((errors) => {
            console.error(errors);
          });
        if (response.length === requests.length) return response;
      } else {
        return true;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async editDocs({ state, commit }, properties) {
    state.filesList.forEach((file, index) => {
      if (
        file &&
        state.allFiles[index] &&
        !_.isEqual(file, state.allFiles[index])
      ) {
        var payload = new FormData();
        properties.props.forEach((item) => {
          if (item === "attachFileId") {
            payload.append(item, file._id);
          } else if (item === "file" && file.file) {
            payload.append(item, file.file);
          } else if (file && file[item]) {
            {
              payload.append(item, file[item]);
            }
          }
        });
        if (properties.attachFileType) {
          payload.append("attachFileType", properties.attachFileType);
        }
        commit("ADD_TO_EDITED_FILES", payload);
      }
    });
    try {
      let requests = [];
      let response;
      if (state.editedFiles.length) {
        state.editedFiles.forEach((c) => {
          requests.push(editDocs(c, properties.id));
        });
        response = await Promise.all(requests)
          .then((responses) => {
            return responses.map((r) => r.data);
            // return [...responses.data]
          })
          .catch((errors) => {
            console.error(errors);
          });
        if (response.length === requests.length) return response;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async deleteDocs({ state, commit }, properties) {
    try {
      let requests = [];
      let response;
      if (state.removalFiles.length) {
        state.removalFiles.forEach((c) => {
          requests.push(removeDocs(c, properties.id));
        });
        response = await Promise.all(requests)
          .then((responses) => {
            return responses.map((r) => r.data);
            // return [...responses.data]
          })
          .catch((errors) => {
            console.error(errors);
          });
        if (response.length === requests.length) return response;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
};
